import { render, staticRenderFns } from "./couchbase.vue?vue&type=template&id=792869ca"
import script from "./couchbase.vue?vue&type=script&lang=js"
export * from "./couchbase.vue?vue&type=script&lang=js"
import style0 from "./couchbase.vue?vue&type=style&index=0&id=792869ca&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports